/**
 * Bài WordPress (anthu.today) LẠC ĐỀ — tin tức bất động sản, công nghệ, du lịch, xã hội…
 * không liên quan trang sức. Gắn noindex trên anthu.vn và bỏ khỏi sitemap để Google
 * đánh giá site chuyên về kim cương/trang sức.
 *
 * Danh sách lấy từ file SEO_anthu_can_chinh.xlsx (tab "1-Bài lạc đề"), quét ngày 26/09/2026.
 * Muốn GIỮ lại bài nào: xoá ID đó khỏi danh sách. Muốn ẩn thêm: thêm ID (xem ID trong
 * link sửa bài WordPress: post.php?post=<ID>).
 *
 * Ngoài danh sách này, bài nào tắt index trong Yoast cũng tự bị noindex (xem isArticleNoindex).
 */
export const OFF_TOPIC_ARTICLE_IDS = new Set<number>([
  78, 89, 136, 141, 151, 156, 176, 193, 200, 204, 208, 214, 219, 224, 228,
  233, 237, 242, 246, 250, 254, 258, 266, 273, 276, 281, 286, 294, 298, 301,
  305, 312, 315, 318, 321, 325, 330, 334, 343, 346, 349, 352, 355, 359, 362,
  365, 369, 372, 375, 384, 387, 390, 393, 397, 401, 405, 408, 411, 414, 417,
  420, 424, 430, 435, 438, 441, 444, 452, 455, 458, 461, 464, 468, 471, 474,
  477, 490, 493, 496, 499, 502, 505, 508, 511, 514, 517, 520, 523, 526, 532,
  537, 542, 550, 553, 556, 560, 564, 567, 570, 577, 581, 584, 592, 595, 598,
  608, 614, 617, 620, 623, 631, 637, 643, 647, 653, 656, 662, 666, 676, 679,
  686, 689, 692, 695, 698, 701, 708, 711, 714, 717, 723, 726, 729, 732, 735,
  738, 741, 744, 747, 750, 755, 758, 763, 766, 769, 772, 775, 778, 781, 790,
  793, 796, 799, 802, 805, 808, 811, 814, 822, 825, 831, 835, 839, 842, 845,
  848, 851, 854, 857, 860, 863, 866, 869, 872, 875, 878, 881, 884, 887, 891,
  894, 897, 900, 906, 909, 912, 915, 918, 921, 924, 927, 930, 933, 936, 941,
  944, 947, 950, 953, 956, 959, 966, 971, 975, 979, 982, 985, 988, 992, 996,
  999, 1002, 1006, 1009, 1012, 1015, 1018, 1022, 1025, 1028, 1031, 1034, 1037, 1040, 1043,
  1046, 1049, 1052, 1057, 1060, 1063, 1066, 1069, 1072, 1075, 1078, 1081, 1084, 1087, 1090,
  1093, 1096, 1099, 1102, 1106, 1109, 1112, 1115, 1118, 1123, 1130, 1133, 1136, 1139, 1142,
  1145, 1148, 1151, 1156, 1159, 1165, 1168, 1171, 1174, 1177, 1180, 1183, 1192, 1195, 1198,
  1201, 1204, 1207, 1210, 1213, 1217, 1220, 1223, 1226, 1229, 1232, 1235, 1238, 1240, 1243,
  1246, 1249, 1252, 1255, 1258, 1262, 1265, 1271, 1274, 1277, 1283, 1289, 1298, 1301, 1308,
  1311, 1314, 1317, 1320, 1323, 1326, 1329, 1334, 1337, 1340, 1343, 1346, 1348, 1351, 1354,
  1357, 1363, 1366, 1369, 1372, 1376, 1379, 1382, 1385, 1388, 1391, 1394, 1397, 1401, 1404,
  1407, 1410, 1413, 1417, 1420, 1424, 1427, 1430, 1433, 1439, 1442, 1445, 1448, 1451, 1454,
  1457, 1463, 1466, 1469, 1472, 1475, 1479, 1482, 1485, 1488, 1491, 1494, 1497, 1500, 1530,
  1533, 1536, 1539, 1542, 1545, 1550, 1553, 1556, 1559, 1562, 1565, 1571, 1574, 1577, 1580,
  1583, 1586, 1591, 1594, 1597, 1600, 1604, 1607, 1610, 1613, 1619, 1622, 1626, 1630, 1633,
  1636, 1639, 1642, 1645, 1648, 1651, 1654, 1657, 1660, 1663, 1666, 1669, 1672, 1676, 1679,
  1682, 1685, 1688, 1691, 1694, 1697, 1700, 1710, 1713, 1716, 1721, 1724, 1727, 1730, 1733,
  1736, 1739, 1742, 1745, 1749, 1752, 1755, 1758, 1761, 1764, 1767, 1770, 1777, 1780, 1783,
  1786, 1792, 1795, 1798, 1801, 1804, 1807, 1815, 1818, 1821, 1824, 1827, 1830, 1833, 1836,
  1839, 1848, 1851, 1854, 1857, 1863, 1866, 1869, 1872, 1875, 1878, 1882, 1885, 1888, 1891,
  1894, 1897, 1902, 1905, 1909, 1912, 1915, 1920, 1923, 1926, 1929, 1932, 1935, 1938, 1941,
  1944, 1947, 1950, 1953, 1956, 1959, 1962, 1965, 1968, 1971, 2150,
]);

/** Chuyên mục WordPress lạc đề: Bất Động Sản (5), Công Nghệ (8), Du Lịch (4).
 *  Bài MỚI đăng vào các chuyên mục này tự noindex, trừ khi tiêu đề nhắc tới trang sức/An Thư. */
const OFF_TOPIC_CATEGORY_IDS = [5, 8, 4];
const JEWELRY_KEYWORDS = /kim cương|trang sức|an thư|anthu|nhẫn|bông tai|dây chuyền|đá quý|ngọc trai/i;

export const isArticleNoindex = (post: any): boolean => {
  if (!post) return false;
  if (post?.yoast_head_json?.robots?.index === 'noindex') return true;
  if (OFF_TOPIC_ARTICLE_IDS.has(Number(post.id))) return true;
  const cats: number[] = Array.isArray(post.categories) ? post.categories : [];
  const title: string = post?.title?.rendered || '';
  return cats.length > 0 && cats.every((c) => OFF_TOPIC_CATEGORY_IDS.includes(c)) && !JEWELRY_KEYWORDS.test(title);
};
